import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import * as authActions from '../../Redux/Auth/AuthActions';
import Navbar from "../../Utils/Navbar/navbar-component";
import Toast from "../../Utils/Toast/toast-component";
import logoImage from '../../Assets/ai-gen-studio.png';

function Terms() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleRedirect = async (e) => {
        e.preventDefault();
        let path = e.target.value;
        const redirectPath = path || '/home';
        dispatch(authActions.redirectScreen(redirectPath));
        navigate(redirectPath);
    }

    return (
        <div>
            <Toast />
            <div className="min-h-full w-full">
                <Navbar />
                <header>
                    <div className="flex justify-center">
                        <div className="flex shadow-xl rounded-full aspect-[1] align-middle border-none mb-4 mx-4">
                            <img
                                alt="..."
                                src={logoImage}
                                style={{ objectFit: 'cover' }}
                                className={`${true ? 'opacity-100' : 'opacity-0'} flex aspect-[1] rounded-full align-middle border-none lg:h-54 lg:w-54 h-34 w-32 transition-all duration-150`}
                                // onLoad={handleImageLoad}
                            />
                        </div>
                    </div>
                </header>
                <main>
                    <div className="flex justify-center mx-auto max-w-7xl sm:px-6 lg:px-8">
                        <div className="flex bg-white dark:bg-black rounded-3xl py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                            <div className="prose dark:prose-invert text-center">
                                <h2>Terms of Service</h2>
                                <p>Last updated: January 23, 2025</p>
                                <p>
                                    This Terms of Service describes the rules and regulations for using
                                    our Service. You can read the full details{" "}
                                    <a
                                        href="https://www.freeprivacypolicy.com/live/d611c39c-ab99-4f8e-acf8-c3534d56a7c2"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-500 underline"
                                    >
                                        here.
                                    </a>
                                </p>
                                <button
                                    className="button-component mt-4"
                                    onClick={handleRedirect}
                                >
                                    Back to homepage
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default Terms;